module.exports = __webpack_public_path__ + "img/logo-mobile.83beaae5.svg";